import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { RichTextViewComponent } from 'libs/shared/feature-rich-text-view/src/lib/rich-text-view.component';
import { ButtonDirective } from 'libs/shared/ui-common/src/lib/components/button/button.directive';
import { DialogRef } from 'libs/shared/ui-common/src/lib/components/dialog/dialog-ref';
import { NamePipe } from 'libs/shared/util-common/src/lib/pipes/name.pipe';

import { DIALOG_DATA, User } from '@treetop/shared/model';

export type UpdateMessageDialogData = {
  message?: string | null;
  infoData: {
    version?: string;
    updatedAt: string;
    publisher?: Partial<User>;
  };
  options?: {
    publisherKey?: string;
    hideDescription?: boolean;
  };
};

@Component({
  selector: 'tt-guideline-update-message-dialog',
  standalone: true,
  templateUrl: './update-message-dialog.component.html',
  styleUrls: ['./update-message-dialog.component.scss'],
  imports: [MatIconModule, TranslocoModule, RichTextViewComponent, NamePipe, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateMessageDialogComponent {
  public data: UpdateMessageDialogData = inject(DIALOG_DATA) as UpdateMessageDialogData;
  private dialogRef: DialogRef<void> = inject(DialogRef);

  protected onClose() {
    this.dialogRef.close();
  }
}
